/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { faHome } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import LocationTracker from "../scenes/Layers/Layer/Components/LocationTracker";

interface BreadcrumbsProps {
    items: { label: string; url: string; isActive: boolean }[];
    homeUrl?: string;
    withLocationTracker?: boolean;
    withBackButton?: boolean;
    children?: React.ReactNode;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, homeUrl, withLocationTracker, withBackButton, children }) => {
    const navigate = useNavigate();

    return (
        <div className="w-100 d-flex justify-content-between align-items-center gap-2">
            <Breadcrumb css={css`> ol { margin-bottom: 0 !important; }`}>
                {withBackButton && (
                    <BreadcrumbItem className="cursor-pointer btn-reset" tag={Link} onClick={() => navigate(-1)}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </BreadcrumbItem>
                )}

                <BreadcrumbItem className="cursor-pointer" tag={Link} to={homeUrl || "/"}>
                    <FontAwesomeIcon icon={faHome} />
                </BreadcrumbItem>

                {items.map((item, index) => (
                    <BreadcrumbItem
                        active={item.isActive}
                        key={index}
                        className={`${!item.isActive ? "cursor-pointer" : ""} mt-0`}
                        tag={item.isActive ? "span" : Link}
                        to={item.url}
                    >
                        <small>{item.label}</small>
                    </BreadcrumbItem>
                ))}
            </Breadcrumb>

            <div className="d-flex flex-column gap-2">
                {withLocationTracker && (
                    <LocationTracker />
                )}

                {children}
            </div>
        </div>
    );
};
